import React, { useState } from "react";
import Autosuggest from "react-autosuggest";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import Search from "@material-ui/icons/Search";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import deburr from "lodash/deburr";
import Fetch from "../fetch/site";
import CircularProgress from "@material-ui/core/CircularProgress";
import multiLang from "../../lang/lang.json";

let mydir = "ltr";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    padding: "30px 0px 0 20px",
    "@global": {
      ".Mui-disabled": {
        background: "orange",
        color: "white"
      },
      ".Mui-focused": {
        color: "#5f5f5f",
        border: "none",
        outline: "none"
      }
    }
  },
  container: {
    position: "relative"
  },
  TextField: {
    width: "100%",
    margin: "8px 0 0 0",
    "@global": {
      ".Mui-focused": {
        color: "#5f5f5f",
        border: "none",
        outline: "none"
      },
      ".MuiOutlinedInput-adornedEnd": {
        paddingRight: "3px"
      },
      fieldset: {
        borderColor: "#5f5f5f !important"
      },
      input: {
        color: "#5f5f5f",
        padding: "10px"
      },
      label: {
        color: "#5f5f5f"
      }
    }
  },
  suggestionsContainerOpen: {
    position: "relative",
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0
  },
  suggestion: {
    display: "block"
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none"
  },
  dir: {
    direction: "rtl",
    padding: "30px 20px 0 0px"
  },
  progress: {
    margin: "0 13px"
  },
  iconbutton: {
    "&:hover": {
      background: "orange"
    },
    padding: "8px 40px 7px",
    background: "orange",
    borderRadius: "0px 4px 4px 0",
    right: "-3px",
    color: "white",
    "@global": {
      ".Mui-disabled": {
        background: "orange",
        color: "white"
      }
    }
  },
  iconbuttonrtl: {
    "&:hover": {
      background: "orange"
    },
    padding: "8px 40px 7px",
    background: "orange",
    borderRadius: "4px 0px 0px 4px",
    right: "8px",
    color: "white",
    "@global": {
      ".Mui-disabled": {
        background: "orange",
        color: "white"
      }
    }
  }
}));

async function fetchData(value) {
  const body = {
    query: `
  query {productWhereNameIs (name:"${value}") {
    id
    categoryId {
      id
      productCategoryProperties {
        id
        caption
        type
        priority
      }
    }
    productAttachments {
      id
      attachFile
      priority
    }
    productPrices{
      id
      fromDate
      toDate
      price
      unit
    }
    name
    title
    height
    weight
    color
    properties{
    productCategoryPropertyId{
      id
      name
    }
    value
    }
    isActive
    inNetwork
    madeInCity
    madeInCountry
    productionDate
}
}
  `
  };
  try {
    const response = await Fetch({ body: JSON.stringify(body) });
    const fetchSuggestions = response.productWhereNameIs;
    console.log("response", response);
    return fetchSuggestions;
  } catch (err) {
    console.log(err);
  }
}

function renderInputComponent(inputProps) {
  const {
    classes,
    inputRef = () => {},
    ref,
    value,
    loading,
    ...other
  } = inputProps;
  // console.log(mydir);

  return (
    <TextField
      variant="outlined"
      className={classes.TextField}
      InputProps={{
        inputRef: node => {
          ref(node);
          inputRef(node);
        },
        classes: {
          input: classes.input
        },
        endAdornment: (
          <InputAdornment position="end">
            {loading ? (
              <CircularProgress
                className={classes.progress}
                color={"inherit"}
                size={20}
                thickness={5}
              />
            ) : (
              <IconButton
                disabled={!value}
                aria-label="Toggle password visibility"
                href={`/search?name=${value}`}
                className={
                  mydir === "ltr" ? classes.iconbutton : classes.iconbuttonrtl
                }
              >
                <Search />
              </IconButton>
            )}
          </InputAdornment>
        )
      }}
      {...other}
    />
  );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
  // console.log("suggestion", suggestion.name);
  const matches = match(suggestion.name, query);
  // console.log("matches", matches);
  const parts = parse(suggestion.name, matches);
  // console.log("parts", parts);
  return (
    <MenuItem
      selected={isHighlighted}
      component="div"
      onClick={() => window.location.replace("/product?name=" + suggestion.id)}
    >
      <div>
        {parts.map(part => (
          <span
            key={part.text}
            style={{ fontWeight: part.highlight ? 500 : 400 }}
          >
            {part.text}
          </span>
        ))}
      </div>
    </MenuItem>
  );
}

async function getSuggestions(value) {
  const inputValue = deburr(value.trim()).toLowerCase();
  const inputLength = inputValue.length;
  // let count = 0;
  const suggestions = await fetchData(value);
  // console.log("getsuggestions", suggestions);
  return inputLength === 0 ? [] : suggestions;
  // suggestions.filter(suggestion => {
  //     const keep =
  //       count < 5 &&
  //       suggestion.name.slice(0, inputLength).toLowerCase() === inputValue;

  //     if (keep) {
  //       count += 1;
  //     }
  //     return keep;
  //   });
}

function getSuggestionValue(suggestion) {
  return suggestion.name;
}

export default function IntegrationAutosuggest(props) {
  const { lang, dir } = props;
  mydir = dir;
  const classes = useStyles();
  const [state, setState] = React.useState({
    single: "",
    popper: ""
  });
  const [stateSuggestions, setSuggestions] = React.useState([]);
  const [loading, setLoading] = useState(false);

  const handleSuggestionsFetchRequested = async ({ value }) => {
    const newsugestion = await getSuggestions(value);
    setSuggestions(newsugestion);
    setLoading(false);
  };

  const handleSuggestionsClearRequested = () => {
    setSuggestions([]);
    setLoading(false);
  };

  const handleChange = name => (event, { newValue }) => {
    setState({
      ...state,
      [name]: newValue
    });
    setLoading(true);
  };

  const autosuggestProps = {
    renderInputComponent,
    suggestions: stateSuggestions,
    onSuggestionsFetchRequested: handleSuggestionsFetchRequested,
    onSuggestionsClearRequested: handleSuggestionsClearRequested,
    getSuggestionValue,
    renderSuggestion
  };

  return (
    <div className={classes.root + " " + (dir === "rtl" ? classes.dir : "")}>
      <Autosuggest
        {...autosuggestProps}
        inputProps={{
          classes,
          id: "react-autosuggest-simple",
          placeholder: `${multiLang["011"][lang]}`,
          value: state.single,
          loading,
          onChange: handleChange("single")
        }}
        theme={{
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion
        }}
        renderSuggestionsContainer={options => (
          <Paper {...options.containerProps} square>
            {options.children}
          </Paper>
        )}
      />
    </div>
  );
}
